import { FeatureFlag } from '../FeatureFlag';

/**
 * Renders the Risk tables (Orders, Executions, Accounts, Positions, and Manual Review) through
 * the new owned grid (`TableModelViewer`, ADR 0014) instead of ag-grid.
 *
 * This is intentionally separate from `enableNewResultsGrid` so each product area can be rolled
 * out and disabled independently.
 */
export const enableNewRiskGrid = new FeatureFlag({
    key: 'enable-new-risk-grid',
    defaultValue: false,
});
